import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Misc } from '../../util/misc';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HeaderComponent } from '../../header/header.component';
import { ToastrComponent } from '../../util/toastr/toastr.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { Usuario } from 'src/app/models/usuario.model';

@Component({
  selector: 'app-trocar-senha-dialog',
  templateUrl: './trocar-senha-dialog.component.html',
  styleUrls: ['./trocar-senha-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrocarSenhaDialogComponent implements OnInit {

  basicForm: UntypedFormGroup;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<HeaderComponent>,
    private fb: UntypedFormBuilder,
    public misc: Misc,
    private authenticationService: AuthenticationService,
    private usuarioService: UsuarioService,
    private toastr: ToastrComponent,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.createForm();
  }

  ngOnInit() {

  }

  createForm() {
    this.basicForm = this.fb.group({
      senhaAtual: ['', Validators.required],
      novaSenha: ['', Validators.required],
      confirmacaoNovaSenha: ['', Validators.required]
    });
  }

  save() {
    this.loading = true;

    if (!this.validar()) {
      return;
    }

    this.authenticationService.login(this.authenticationService.currentUserValue.userName, this.basicForm.value.senhaAtual).subscribe(
      result => {
        const usuario: Usuario = {
          id: result.id,
          senha: this.basicForm.value.novaSenha,
          ativo: true,
          dtInclusao: new Date(),
          login: result.userName,
          email: result.email,
          tb_usuario_perfil: null,
          dtAlteracao: null
        };

        this.usuarioService.update(usuario).subscribe(
          () => {
            this.dialogRef.close('ok');
          },
          error => {
            this.misc.processError(error, 'Não foi possível atualizar a senha.');
          },
          () => {
            this.loading = false;
          }
        );
      },
      error => {
        this.misc.processError(error, null);

        this.loading = false;
      }
    );
  }

  close(): void {
    this.dialogRef.close();
  }

  validar(): boolean {
    let errorMessage = '';

    if (!this.basicForm.value.senhaAtual) {
      errorMessage = 'Favor informar a senha atual.';
    } else if (!this.basicForm.value.novaSenha) {
      errorMessage = 'Favor informar a nova senha.';
    } else if (!this.basicForm.value.confirmacaoNovaSenha) {
      errorMessage = 'Favor informar a confirmação da senha.';
    } else if (this.basicForm.value.novaSenha !== this.basicForm.value.confirmacaoNovaSenha) {
      errorMessage = 'A nova senha e a confirmação não conferem.';
    }

    if (errorMessage) {
      this.toastr.mostrarMensagem('aviso', 'Troca de Senha', errorMessage);

      return false;
    }

    return true;
  }
}
